import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2
} from '@angular/core';

@Component({
  selector: 'cs-popup-actions',
  standalone: false,
  templateUrl: './popup-actions.component.html',
  styleUrls: ['./popup-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupActionsComponent implements OnInit {
  @Input() public position: string = 'center';

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef<HTMLElement>
  ) {}

  public ngOnInit(): void {
    if (this.position === 'left') {
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        'justify-content',
        'flex-start'
      );
    } else {
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        'justify-content',
        'center'
      );
    }
  }
}
